import { useRouter } from 'next/navigation';
import { useCallback, useEffect, useRef } from 'react';

const DELAY = 200;
export const useBack = () => {
  const router = useRouter();
  const timeout = useRef<NodeJS.Timeout>(null);

  const back = useCallback(
    (fallbackHref: string) => {
      router.back();

      timeout.current = setTimeout(() => {
        router.push(fallbackHref);
      }, DELAY);
    },
    [router],
  );

  useEffect(() => {
    return () => {
      if (timeout.current) clearTimeout(timeout.current);
    };
  });

  return back;
};
